/* Farah – size chart + bundle */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var EN = (document.documentElement.lang || '').indexOf('en') === 0;
  var L = function (ar, en) { return EN ? en : ar; };
  function openCart() {
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    setTimeout(function () {
      try { var jq = window.jQuery_T4NT || window.jQuery; if (window.T4SThemeSP && T4SThemeSP.Drawer && jq) { T4SThemeSP.Drawer.opend(jq('#t4s-mini_cart')); return; } } catch (e) {}
      location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
    }, 350);
  }
  /* ---- Size chart modal ---- */
  document.addEventListener('click', function (e) {
    var m = $('[data-fr-sc]'); if (!m) return;
    if (e.target.closest('[data-fr-sc-open]')) { m.hidden = false; }
    if (e.target.closest('[data-fr-sc-close]')) { m.hidden = true; }
  });

  /* ---- Bundle "اطلبيهم سوا" ---- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }
  function initBundle(root) {
    $$('[data-fr-bundle]', root).forEach(function (b) {
      if (b.dataset.frReady) return; b.dataset.frReady = '1';
      var fmt = ''; try { fmt = JSON.parse(b.querySelector('[data-fr-money]').textContent); } catch (e) {}
      var cur = b.querySelector('[data-current]');
      function syncCurrent() {
        var sel = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (sel && cur && sel.value) {
          cur.dataset.id = sel.value;
          var opt = sel.options ? sel.options[sel.selectedIndex] : null;
          var p = opt && (opt.getAttribute('data-price') || opt.dataset.price);
          if (p) cur.dataset.price = p;
        }
      }
      function total() {
        var t = 0; $$('input[type=checkbox]', b).forEach(function (c) { if (c.checked) t += Number(c.dataset.price || 0); });
        b.querySelector('[data-fr-bundle-total]').textContent = money(t, fmt);
      }
      b.addEventListener('change', total);
      document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('form[action*="/cart/add"]')) { syncCurrent(); total(); } });
      total();
      b.querySelector('[data-fr-bundle-add]').addEventListener('click', function () {
        syncCurrent();
        var btn = this, items = $$('input[type=checkbox]', b).filter(function (c) { return c.checked; }).map(function (c) { return { id: Number(c.dataset.id), quantity: 1 }; });
        if (!items.length) return;
        btn.disabled = true; var label = btn.textContent; btn.textContent = L('...جاري الإضافة', 'Adding...');
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { btn.textContent = L('تمت الإضافة ✓', 'Added ✓'); return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
          .then(function (c) { $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); openCart(); })
          .catch(function (err) { btn.textContent = (err && err.description) || L('حصلت مشكلة، جربي تاني', 'Something went wrong, try again'); })
          .finally(function () { setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1600); });
      });
    });
  }

  function init(root) { initBundle(root); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
